import React from "react";

interface LoadingHeaderProps {
  pageRoute: string;
}

// TODO (Yuxin, 2026-01-25): Temporarily disabled loading header
const LoadingHeader: React.FC<LoadingHeaderProps> = () => {
  return null;
};

export default LoadingHeader;
